/** Tokens CSS das telas internas (styled-components) do módulo Controladoria. */

export const LIGHT_CONTENT_VARS = {
  "--ctrl-text": "#152A36",
  "--ctrl-text-muted": "#5A6F7C",
  "--ctrl-label": "#64748B",
  "--ctrl-surface": "#FFFFFF",
  "--ctrl-surface-muted": "#F0F3F5",
  "--ctrl-surface-soft": "#F8FAFC",
  "--ctrl-border": "#D3D3D3",
  "--ctrl-border-soft": "#E2E8F0",
  "--ctrl-thead": "#F0F0F0",
  "--ctrl-row-odd": "#FFFFFF",
  "--ctrl-row-even": "#F9F9F9",
  "--ctrl-row-hover": "#E8F0FE",
  "--ctrl-scrollbar": "#C1C1C1",
  "--ctrl-scrollbar-track": "#F0F0F0",
  "--ctrl-icon": "#333333",
};

export const DARK_CONTENT_VARS = {
  "--ctrl-text": "#F2F7FA",
  "--ctrl-text-muted": "#B7C9D4",
  "--ctrl-label": "#8FAABB",
  "--ctrl-surface": "#122230",
  "--ctrl-surface-muted": "#1A2D3A",
  "--ctrl-surface-soft": "#152736",
  "--ctrl-border": "rgba(255, 255, 255, 0.14)",
  "--ctrl-border-soft": "rgba(255, 255, 255, 0.1)",
  "--ctrl-thead": "#1A2D3A",
  "--ctrl-row-odd": "#122230",
  "--ctrl-row-even": "#0F1C26",
  "--ctrl-row-hover": "#1E3A4A",
  "--ctrl-scrollbar": "#3D5A6C",
  "--ctrl-scrollbar-track": "#0F1C26",
  "--ctrl-icon": "#E8F0F4",
};

/**
 * @param {'light' | 'dark'} mode
 * @param {{ rootSelector: string, contentSelector: string }} scope
 */
export const buildLegacyContentOverrides = (
  mode,
  { rootSelector, contentSelector }
) => {
  if (mode !== "dark") return {};

  const content = `${rootSelector} ${contentSelector}`;

  return {
    [content]: {
      color: "var(--ctrl-text)",
    },
    [`${content} h1, ${content} h2, ${content} h3, ${content} h4`]: {
      color: "var(--ctrl-text)",
    },
    [`${content} label`]: {
      color: "var(--ctrl-label)",
    },
    [`${content} input:not([type="submit"]):not([type="button"]), ${content} select, ${content} textarea`]:
      {
        color: "var(--ctrl-text)",
        backgroundColor: "var(--ctrl-surface)",
        borderColor: "var(--ctrl-border)",
        WebkitTextFillColor: "var(--ctrl-text)",
      },
  };
};

export const varsToStyleObject = (vars) => vars;
